import { BaseFloatDataChannel } from "./BaseDataChannel";

export class GpsChannel extends BaseFloatDataChannel {
  public getConfiguration() {
    return {
      name: 'gps'
    };
  }
}